export const SUPPORT_REQUEST_TYPES = "/support-requests/types"

export const SUPPORT_REQUEST_STEP_TYPES = "/support-requests/Steptypes"

export const SUPPORT_REQUESTS = "/support-requests/:page"

export const SUPPORT_REQUESTS_ASSIGN_USER =
  "/support-requests/:id/assign/:userId"

export const SUPPORT_REQUESTS_RESOLVE = "/support-requests/:id/resolve"

export const GET_OPENED_SUPPORT = "/support/opened"

export const OPEN_SUPPORT = "/support/open"

export const CLOSE_SUPPORT = "/support/close/:id"

export const CREATE_REQUEST = "/support/:supportId/orders/:orderId/requests"

export const GET_REQUEST_AR = "/support-requests/filter/id/:orderId"

export const GET_CHECKBOXES = "/support/report/checkboxes"

export const MOVE_REQUEST = "/support-requests/step/move/"

export const MOVE_QUEUE = "/support-requests/queue/move/"

export const MARK_AS_SOLVED_V2 = "/support-requests/v2/:id/resolve"

export const GET_REQUEST_INFO = "/support-requests/start/:supportRequestId"

export const GET_REQUEST_STEPS =
  "/support-requests/requestSteps/:supportRequestId"

export const POST_ENCERRAMENTO = "/support-requests/close/:supportRequestId"

export const POST_NOTE = "/support-requests/note/:supportRequestId"

export const QUEUES = "/queue"

export const SUPPORT_REQUEST_QUEUES_TYPES = "/queue/queueTypes"

export const ALL_QUEUES = "/queue/all"

export const GET_QUEUE = "/queue/:id"

export const PATCH_QUEUE = "/queue/:id"

export const DELETE_QUEUE = "/queue/:id"

export const FORCE_DELETE_QUEUE = "/queue/:id/force"

export const RESTORE_QUEUE = "/queue/:id/restore"

export const CHANNELS = "/channel"

export const SUPPORT_REQUEST_CHANNELS_TYPES = "/channel/channelTypes"

export const ALL_CHANNELS = "/channel/all"

export const PATCH_CHANNEL = "/channel/:id"

export const DELETE_CHANNEL = "/channel/:id"

export const FORCE_DELETE_CHANNEL = "/channel/:id/force"

export const RESTORE_CHANNEL = "/channel/:id/restore"

export const STEPS = "/step"

export const GET_ALL_STEPS = "/step/all"

export const PATCH_STEP = "/step/:id"

export const DELETE_STEP = "/step/:id"

export const FORCE_DELETE_STEP = "/step/:id/force"

export const RESTORE_STEP = "/step/:id/restore"

export const SUPPORT_REQUEST_TYPE = "/support-request-type"

export const GET_SUPPORT_REQUEST_TYPE_BY_ID = "/support-request-type/:id"

export const GET_ALL_SUPPORT_REQUEST_TYPE = "/support-request-type/all"

export const PATCH_SUPPORT_REQUEST_TYPE = "/support-request-type/:id"

export const RESTORE_SUPPORT_REQUEST_TYPE = "/support-request-type/:id/restore"

export const DELETE_SUPPORT_REQUEST_TYPE = "/support-request-type/:id"

export const VIA_CEP = "external/consultaCEP/:cep"

export const DOWNLOAD_ATTATCHMENT = "/support-requests/download/:filename"
